<!--
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-10-24 10:31:53
 * @LastEditors: cxh
-->
<template>
  <cos-table serial :columns="columns" tableId="fbuPartnerContactsTable" @fetch="fetch" ref="table">
    <template #bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'action'">
        <a-button type="link" @click="handleEdit(record)" v-permission="'fbu_partner_counterpart_edit_btn'">
          编辑
        </a-button>
        <a-button type="link" @click="handleDelete(record)" v-permission="'fbu_partner_counterpart_del_btn'">
          删除
        </a-button>
      </template>
    </template>
  </cos-table>
  <cos-footer-button :loading="loading" returnName="DcCosZbuPartnerManage">
    <a-button type="primary" @click="handleAdd()" :loading="loading" v-permission="'fbu_partner_counterpart_add_btn'"
      >新增对接人</a-button
    >
  </cos-footer-button>
  <cos-modal
    v-model:visible="visible"
    :title="form.id ? '编辑' : '新增'"
    width="870px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="form" ref="formRef" v-if="visible">
      <dc-layout-card :span="12">
        <dc-form-item name="partnerName" label="合作伙伴名称" :span="12">
          <a-input v-model:value="partner.partnerName" placeholder="请输入" :disabled="true" />
        </dc-form-item>
        <dc-form-item
          name="name"
          :span="12"
          :rules="[
            {
              required: true,
              message: '请输入'
            },
            {
              validator: concatNameValidate
            }
          ]"
          label="对接人名称"
        >
          <a-input v-model:value="form.name" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="性别" :span="12">
          <CosSelect
            filterNoVal
            v-model:value="form.sex"
            :options="dataConfig.genderEnum"
            placeholder="请选择"
            allow-clear
          >
          </CosSelect>
        </dc-form-item>
        <dc-form-item label="角色" :span="12">
          <ParamCodesSelect filterNoVal :options="paramCodeData.zbu_partner_role_fbu" v-model:value="form.role" />
        </dc-form-item>
        <dc-form-item
          name="mobile"
          label="手机号"
          :span="12"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <a-input v-model:value="form.mobile" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="email"
          label="邮箱"
          :span="12"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <a-input v-model:value="form.email" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="wechat"
          :span="12"
          label="微信号"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <a-input v-model:value="form.wechat" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="qq"
          :span="12"
          label="QQ号"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <a-input v-model:value="form.qq" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="tel"
          :span="12"
          label="固定电话"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <a-input v-model:value="form.tel" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item label="备注" :span="24">
          <CosTextarea v-model:value="form.remark" :maxlength="2000" placeholder="请输入" />
        </dc-form-item>
      </dc-layout-card>
    </a-form>
  </cos-modal>
</template>
<script setup lang="ts">
import { onMounted, ref, computed, reactive } from 'vue'
import Modal from '@/hooks/modalType'
import { DcMessage } from '@dc-platform/dc-components'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import {
  partnerContactDelete,
  partnerContactAdd,
  partnerContactEdit,
  partnerContactList
} from '@/api/marketing/marketingManage'
import { useRoute } from 'vue-router'
import type { PartnerManage } from '@/typings/api/marketingManage'
import { contactValidate, concatNameValidate } from '@/utils/validate'
import { listByParamCodes } from '@/api/common'
const route = useRoute()
const table = ref()
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PartnerManage['partnerContact']>({})
const partner = ref<any>({
  id: null,
  partnerName: ''
})
const paramCodeData = reactive<{
  zbu_partner_role_fbu: []
}>({
  zbu_partner_role_fbu: []
})
defineProps({
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: true
  }
})
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.id) {
    partnerContactList({
      partnerId: route.query.id,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: ['zbu_partner_role_fbu']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
onMounted(() => {
  getByParamCodes()
  partner.value = {
    id: route.query.id,
    partnerName: route.query.name
  }
})
// 新增
const handleAdd = () => {
  form.value = {}
  visible.value = true
}
// 编辑
const handleEdit = (row: PartnerManage['partnerContact']) => {
  form.value = { ...row }
  visible.value = true
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      if (form.value?.id) {
        await partnerContactEdit(form.value)
        DcMessage.success('编辑成功')
      } else {
        await partnerContactAdd({ ...form.value, partnerId: partner.value.id })
        DcMessage.success('新增成功')
      }
      visible.value = false
      success()
    } catch (error) {}
    loading.value = false
  })
}
// 删除
const handleDelete = (row: PartnerManage['partnerContact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      partnerContactDelete({ id: row.id }).then((res) => {
        table.value.delFetch()
        DcMessage.success('删除成功')
      })
    }
  })
}
const success = () => {
  table.value.fetch()
}
const columns = computed(() => [
  {
    title: '对接人名称',
    dataIndex: 'name'
  },
  {
    title: '性别',
    dataIndex: 'sex',
    dicData: dataConfig.genderEnum,
    filterNoVal: true
  },
  {
    title: '角色',
    dataIndex: 'role',
    dicData: paramCodeData.zbu_partner_role_fbu,
    filterNoVal: true
  },
  {
    title: '手机号',
    dataIndex: 'mobile'
  },
  {
    title: '邮箱',
    dataIndex: 'email'
  },
  {
    title: '微信号',
    dataIndex: 'wechat'
  },
  {
    title: 'QQ号',
    dataIndex: 'qq'
  },
  {
    title: '固定电话',
    dataIndex: 'tel'
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 180
  }
])
</script>
<script lang="ts">
export default { name: 'ContactsTable' }
</script>
<style lang="scss" scoped></style>
